import type { ISwSettings } from "app/@types/ISwSettings";
import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import AddIntegrationDropdown
    from "app/pages/sales-intelligence/modules/manage-integrations/components/AddIntegrationDropdown/AddIntegrationDropdown";
import CardsWrapper
    from "app/pages/sales-intelligence/modules/manage-integrations/components/CardsWrapper/CardsWrapper";
import {
    ExtensionCard
} from "app/pages/sales-intelligence/modules/manage-integrations/components/integration-cards/ExtensionCard/ExtensionCard";
import MyIntegrationsSectionContainer
    from "app/pages/sales-intelligence/modules/manage-integrations/containers/MyIntegrationsSectionContainer";
import { isAfterTrial, isNoTouch, isTrial } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import {
    SuppressionListSectionContainer
} from "../../containers/SuppressionListSectionContainer/SuppressionListSectionContainer";
import { MANAGEMENT_MY_INTEGRATIONS, MANAGEMENT_SETTINGS_TITLE } from "../../translations/managementKeys";
import ManagementPageHeader from "../ManagementPageHeader/ManagementPageHeader";
import ManagementPageWrapper from "../ManagementPageWrapper/ManagementPageWrapper";

const Management = () => {
    const isExtensionSectionHidden =
        isTrial(swSettings as ISwSettings) ||
        isAfterTrial(swSettings as ISwSettings) ||
        isNoTouch(swSettings as ISwSettings);

    return (
        <ManagementPageWrapper>
            <ManagementPageHeader text={translate(MANAGEMENT_MY_INTEGRATIONS)}>
                <AddIntegrationDropdown />
            </ManagementPageHeader>

            <MyIntegrationsSectionContainer />

            <CardsWrapper title={translate(MANAGEMENT_SETTINGS_TITLE)}>
                {isExtensionSectionHidden ? null : <ExtensionCard />}
                <SuppressionListSectionContainer />
            </CardsWrapper>
        </ManagementPageWrapper>
    );
};

export default Management;
